import type {
  HeadlineResponsePersonBaseRelatedPagedData,
  PlayerProfileResponse,
} from '@on3/api';
import { CompactHeader } from 'components/Db/Profile/Header/CompactHeader';
import { ArticleFeedArticle } from 'components/Headlines/ArticleFeed/ArticleFeed';
import { DatabaseLayout } from 'components/Layouts/DatabaseLayout';
import { Pagination } from 'components/UI/Pagination/Pagination';
import { Text } from 'components/UI/Typography/Text';
import { useRouter } from 'next/router';
import { useCallback, useState } from 'react';

export interface IPlayerNewsPageProps {
  recruitsArticles?: HeadlineResponsePersonBaseRelatedPagedData | null;
  basicInfo?: PlayerProfileResponse | null;
}

export const PlayerNews = ({
  recruitsArticles,
  basicInfo,
}: IPlayerNewsPageProps) => {
  const { list, pagination } = recruitsArticles || {};
  const [pageNumber, setPageNumber] = useState(pagination?.currentPage);
  const router = useRouter();
  const hasPagination = pagination?.count && pagination?.count > 25;

  const handleChange = useCallback(
    (_event: any, value: any) => {
      setPageNumber(value);
      router.push({
        pathname: router.pathname,
        query: { ...router.query, page: value },
      });
    },
    [router],
  );

  return (
    <DatabaseLayout>
      <section>
        <CompactHeader basicInfo={basicInfo} />
        {hasPagination && (
          <Pagination
            count={pagination?.pageCount}
            onChange={handleChange}
            page={pageNumber}
          />
        )}
        <section>
          {list?.length ? (
            list?.map((item) => {
              return <ArticleFeedArticle {...item} key={item.key} />;
            })
          ) : (
            <Text variant="caption">No News</Text>
          )}
        </section>
        {hasPagination && (
          <Pagination
            count={pagination?.pageCount}
            onChange={handleChange}
            page={pageNumber}
          />
        )}
      </section>
    </DatabaseLayout>
  );
};
